import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const addDevice = createAsyncThunk("addDevice", async (data) => {
  try {
    const response = await axiosHttp.post("attendance/admin/devices/register-physical", data);
    return response.data;
  } catch (error) {
    throw error.response.data.message;
  }
});

//slice
const addDeviceSlice = createSlice({
  name: "addDevice",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addDevice.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(addDevice.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(addDevice.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export default addDeviceSlice.reducer;
export const { resetAddDeviceState } = addDeviceSlice.actions;
